import { Sprite, Texture, AnimatedSprite, Text, BitmapText } from "pixi.js";
import PressButton from "./PressButton.js";
import Button from "./Button.js";
import ToggleButton from "./ToggleButton.js";

import SimpleButton from "./SimpleButton.js";
import SwitchButton from "./SwitchButton.js";
import MouseOverSprite from "./MouseOverSprite.js";
import { EVENTS } from "../lib/constants.js";
import { GameConfigs } from "../lib/globals/GameConfigs.js";
import SpinButton from "./SpinButton.js";
import ActionButton from "./ActionButton.js";
import ToggleButtonNew from "./ToggleButtonNew.js";
import StopButton from "./StopButton.js";

class VisualComponent extends Sprite {
  constructor(obj) {
    super();
    this.config = obj;
    this.sprites = [];

    window.addEventListener(
      EVENTS.SETTINGS_UPDATE,
      this.settingsChanged.bind(this),
      false
    );
    for (let i = 0; i < obj.components.length; i++) {
      const element = obj.components[i];
      switch (element.type) {
        case "Sprite":
          this.createSprite(element);
          break;
        case "SwitchButton":
          this.createSwitchButton(element);
          break;
        case "SimpleButton":
          this.createSimpleButton(element);
          break;
        case "ActionButton":
          this.createActionButton(element);
          break;
        case "PressButton":
          this.createPressButton(element);
          break;
        case "SpinButton":
          this.createSpinButton(element);
          break;
        case "StopButton":
          this.createStopButton(element);
          break;
        case "ToggleButton":
          this.createToggleButton(element);
          break;
        case "ToggleButtonNew":
          this.createToggleButtonNew(element);
          break;
        case "MouseOverSprite":
          this.createMouseOverSprite(element);
          break;
        case "AnimatedSprite":
          this.createAnimatedSprite(element);
          break;
        case "Text":
          this.createText(element);
          break;
        case "CustomText":
          this.createCustomText(element);
          break;
        case "Button":
          this.createButton(element);
          break;
        case "VisualComponent":
          this.createVisualComponent(element);
          break;

        default:
          break;
      }
    }
    if (this.config.controllers !== undefined) {
      for (let i = 0; i < this.config.controllers.length; i++) {
        const element = this.config.controllers[i];
        var controller = new element.Controller(this, element.config);
        this[element.name] = controller;
      }
    }
  }

  createButton(obj) {
    obj.handler = this.clickHandler.bind(this);
    var b = new Button(obj);
    //if (obj.components && obj.components.length) {
    //  var vc = new VisualComponent(obj);
    //  b.addChild(vc);
    //  this[obj.name] = vc;
    // }
    this.addComponent(obj, b);
  }

  createCustomText(obj) {
    var text = new BitmapText(
      window.lm[obj.text].value,
      window.lm[obj.text].config
    );
    text.name = obj.name;
    if (obj.anchor) {
      text.anchor.x = obj.anchor.x;
      text.anchor.y = obj.anchor.y;
    }
    this.addComponent(obj, text);
  }
  createText(obj) {
    var text = new Text(window.lm[obj.text].value, window.lm[obj.text].config);
    text.name = obj.name;
    this.addComponent(obj, text);
  }

  createSwitchButton(obj) {
    obj.handler = this.clickHandler.bind(this);
    var switchButton = new SwitchButton(obj);
    switchButton.name = obj.name;
    this.addComponent(obj, switchButton);
  }

  createActionButton(obj) {
    obj.handler = this.clickHandler.bind(this);
    var actionButton = new ActionButton(obj);
    actionButton.name = obj.name;
    this.addComponent(obj, actionButton);
  }

  createSimpleButton(obj) {
    obj.handler = this.clickHandler.bind(this);
    var simpleButton = new SimpleButton(obj);
    simpleButton.name = obj.name;
    this.addComponent(obj, simpleButton);
  }

  createPressButton(obj) {
    obj.handler = this.clickHandler.bind(this);
    var pressButton = new PressButton(obj);
    pressButton.name = obj.name;
    this.addComponent(obj, pressButton);
  }

  createSpinButton(obj) {
    obj.handler = this.clickHandler.bind(this);
    var spinButton = new SpinButton(obj);
    spinButton.name = obj.name;
    this.addComponent(obj, spinButton);
  }

  createStopButton(obj) {
    obj.handler = this.clickHandler.bind(this);
    var stopButton = new StopButton(obj);
    stopButton.name = obj.name;
    this.addComponent(obj, stopButton);
  }

  createToggleButton(obj) {
    obj.handler = this.clickHandler.bind(this);
    var toggleButton = new ToggleButton(obj);
    // if(obj.scale){
    //   toggleButton.scale.set(obj.scale.x, obj.scale.y)
    // }
    toggleButton.name = obj.name;
    this.addComponent(obj, toggleButton);
  }

  createToggleButtonNew(obj) {
    obj.handler = this.clickHandler.bind(this);
    var toggleButton = new ToggleButtonNew(obj);
    // if(obj.scale){
    //   toggleButton.scale.set(obj.scale.x, obj.scale.y)
    // }
    toggleButton.name = obj.name;
    this.addComponent(obj, toggleButton);
  }

  createMouseOverSprite(obj) {
    var mouseOver = new MouseOverSprite(obj);
    mouseOver.name = obj.name;
    if (obj.config) {
      mouseOver.config = obj.config;
    }
    // if (obj.components && obj.components.length) {
    //   var vc = new Sprite()
    //   mouseOver.addChild(vc)
    //   this[obj.name] = vc
    // }
    this.addComponent(obj, mouseOver);
  }

  createSprite(obj) {
    var sp;
    if (obj.img) {
      sp = new Sprite(Texture.from(obj.img));
    } else {
      sp = new Sprite();
    }
    if (obj.alpha) {
      sp.alpha = obj.alpha;
    }
    if (obj.anchor) {
      sp.anchor.set(obj.anchor.x, obj.anchor.y);
    }
    if (obj.rotation) {
      sp.rotation = obj.rotation;
    }
    sp.name = obj.name;
    this.addComponent(obj, sp);
  }

  createAnimatedSprite(obj) {
    const anim = this.getAnimatedSprite(obj);
    if (!GameConfigs.settings.game_animation) {
      if (obj.animation.animatable === undefined) anim.gotoAndStop(0);
    } else {
      anim.play();
    }
    if (obj.animation.rotation) {
      anim.rotation = obj.animation.rotation;
    }
    if (obj.animation.anchor) {
      anim.anchor.set(obj.animation.anchor.x, obj.animation.anchor.y);
    }
    anim.name = obj.name;
    if (obj.animation.animatable === undefined) this.sprites.push(anim);
    this.addComponent(obj, anim);
  }

  createVisualComponent(obj) {
    var vc = new VisualComponent(obj.component);
    vc.name = obj.name;
    this.addComponent(obj, vc);
  }

  clickHandler(name) {
    if (this.config.handler) {
      this.config.handler(name);
    }
  }

  addComponent(obj, component) {
    this[obj.name] = component;
    if (obj.position) {
      component.position.set(obj.position.x, obj.position.y);
    }
    if (obj.scale) {
      component.scale.set(obj.scale.x, obj.scale.y);
    }
    if (obj.anchor) {
      component.anchor.set(obj.anchor.x, obj.anchor.y);
    }

    if (obj.components && obj.components.length) {
      var vc = new VisualComponent(obj);
      if (!obj.position) {
      } else {
        vc.position.set(obj.position.x, obj.position.y);
      }

      component.position.set(0, 0);
      component.addChild(vc);
      this[obj.name] = vc;
    }
    if (obj.name) {
      //this[obj.name] = component
    }
    this.addChild(component);
  }

  getAnimatedSprite(obj) {
    const pattern = obj.animation.pattern.split("$");
    const textureArray = [];
    this.animate(obj.animation, pattern, textureArray);
    let anim = new AnimatedSprite(textureArray);
    anim.loop = obj.animation.loop;
    anim.animationSpeed = obj.animation.speed;
    if (obj.animation.scale) {
      anim.scale.x = obj.animation.scale.x;
      anim.scale.y = obj.animation.scale.y;
    }
    if (obj.animation.anchor) {
      anim.anchor.set(obj.animation.anchor.x, obj.animation.anchor.y);
    }
    if (obj.animation.rotation) {
      anim.rotation = obj.animation.rotation;
    }
    return anim;
  }
  resize(w, h) {
    if (this.config.controllers !== undefined) {
      for (let i = 0; i < this.config.controllers.length; i++) {
        const element = this.config.controllers[i];
        if (this[element.name].resize) {
          this[element.name].resize(w, h);
        }
      }
    }
  }
  animate(obj, pattern, arr) {
    for (let i = obj.start; i <= obj.end; i += 1) {
      let current =
        pattern[0] + String(i).padStart(obj.precision, "0") + pattern[1];
      const texture = Texture.from(current);
      arr.push(texture);
    }
  }

  settingsChanged(e) {
    if (e.detail.data.game_animation === undefined) {
      return;
    }
    for (var i = 0; i < this.sprites.length; i++) {
      if (!e.detail.data.game_animation) {
        this.sprites[i].gotoAndStop(0);
      } else {
        this.sprites[i].gotoAndPlay(0);
      }
    }
  }
}

export default VisualComponent;
